import React, { FunctionComponent } from "react";

import P from "@/apps/ui/components/P";
import ReduxApiMiddlewareError from "@/apps/ui/components/ReduxApiMiddlewareError";

import { IsEmptyCampaignsType } from "../../selectors/getIsEmptyCampaigns";
import { State as CampaignsState } from "../../store/campaigns/types";
import ListItem from "../ListItem";

import styleCss from "./style.css";

interface ListProps extends CampaignsState {
  isEmptyCampaigns: IsEmptyCampaignsType;
}

const List: FunctionComponent<ListProps> = function ({ campaigns, error, isEmptyCampaigns }) {
  return (
    <ReduxApiMiddlewareError error={error}>
      {isEmptyCampaigns && <P className={styleCss.empty}>Указанный VIN не участвует в сервисных кампаниях.</P>}
      {campaigns && (
        <div className={styleCss.list}>
          {campaigns.map(({ id, code, description, descriptionDetailed, status }) => (
            <ListItem
              key={id}
              code={code}
              description={description}
              descriptionDetailed={descriptionDetailed}
              status={status}
            />
          ))}
        </div>
      )}
    </ReduxApiMiddlewareError>
  );
};

export default List;
